import { assetPath, cn } from '@/lib/utils';

/** The EY-Parthenon tagline lockup with the product name, for screens outside the app shell. */
export function BrandLockup({ className }: { readonly className?: string }) {
  return (
    <div className={cn('flex flex-col items-start', className)}>
      <img
        src={assetPath('/logos/eyp-logo-tagline-light.svg')}
        alt="EY-Parthenon"
        className="h-auto w-44 dark:hidden"
      />
      <img
        src={assetPath('/logos/eyp-logo-tagline-dark.svg')}
        alt="EY-Parthenon"
        className="hidden h-auto w-44 dark:block"
      />
      <p className="mt-2 w-44 border-t border-border/60 pt-1.5 font-heading text-sm font-bold tracking-tight text-foreground">
        Contract Analyzer
      </p>
    </div>
  );
}
